import subUsersReserPasswordRedux from 'Modules/users/.components/resetSubUserPassword/redux/reducer';
import sendWelcomeEmailRedux from 'Modules/users/.components/sendWelcomeEmail/redux/reducer';


//export redux objects
export default {
	subUsersReserPasswordRedux,
	sendWelcomeEmailRedux
};